module.exports = __webpack_public_path__ + "static/media/300_Racoon_coins.67359c2d.webp";